const paymentConfirmationFormResources = {
    labelForPIN: 'PIN Code',
};
export default paymentConfirmationFormResources;
